import { createAction } from "@reduxjs/toolkit";
import { TalesTournament } from "../../../utils/types/TalesTournament";

export const setTournamentData = createAction<TalesTournament[] | null>(
  "tournament/setData",
);
